// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './SearchGroupList.module.css';

/**
 * SearchGroupList
 * @template T - Type of the items in the array
 * @param {object} params
 * @param {boolean} [params.hasLabel = false] - Whether the list has a label
 * @param {string} [params.label] - Label text
 * @param {Array<T & {id: string}>} params.items - Items to iterate over
 * @param {(item: T) => import('react').ReactNode} params.children - Render function called for each item
 * @param {import('react').ReactNode | null} [params.action = null] - Action to display in the header
 * @returns {JSX.Element} SearchGroupList component
 */
function SearchGroupList({
  hasLabel = false, label, items, children, action = null,
}) {
  return (
    <div className={cn([styles.container, hasLabel && styles['container-with-label']])}>
      {action && hasLabel ? (
        <div className={styles.title}>
          {action}
          <SearchGroupListLabel>{label}</SearchGroupListLabel>
        </div>
      ) : null}
      {!action && hasLabel ? (
        <div className={styles.title}>
          <SearchGroupListLabel>{label}</SearchGroupListLabel>
        </div>
      ) : null}
      <div className={styles.list}>
        {items?.map((item) => (
          <div key={item.id} className={styles.row}>
            {children(item)}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * SearchGroupListLabel
 * @param {object} params
 * @param {string | React.ReactNode} params.children - Label text
 * @returns {JSX.Element} SearchGroupListLabel component
 */
export function SearchGroupListLabel({ children }) {
  return (
    <span
      className={styles['title-text']}
      title={typeof children === 'string' ? children : null}
    >
      {children}
    </span>
  );
}

export default SearchGroupList;
